import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteResourceCard } from 'bundles/ent-website/queries/EntWebsiteResourceHub';

export const entWebsiteResourceCardsSearchQuery = contentfulGql`#graphql
  ${entWebsiteResourceCard}
  query entWebsiteResourceCardsSearch (
    $includeUseCases: [String]
    $excludeUseCases: [String]
    $domains: [String]
    $contentTypes: [String]
    $excludeSlugs: [String]
    $searchString: String
    $preview: Boolean
  ) {
    entWebsiteResourceCardCollection(
      where: {
        useCases_contains_none: $excludeUseCases
        useCases_contains_some: $includeUseCases
        domains_contains_some: $domains
        headline_contains: $searchString
        contentType_in: $contentTypes
        slug_not_in: $excludeSlugs
      }
      preview: $preview
      order: priority_DESC
    ) {
      items {
        ...EntWebsiteResourceCard
      }
    }
  }
`;
